var _defs, _style, _defs2, _path, _path2, _path3, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAdWLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 257.99999 89.000002",
    width: 258,
    height: 89,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs41"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{clip-path:url(#SVGID_4_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "g16",
    transform: "translate(-195,-253.3)"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", {
    id: "defs5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 195,
    y: 253.3,
    width: 451.89999,
    height: 89
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#SVGID_1_",
    style: {
      overflow: "visible"
    },
    id: "use7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 243.1,296.7 h -7.6 v 30.8 l 6.8,0.6 c 10.1,0 13.9,-7.3 13.9,-16.4 -0.1,-10.1 -5.8,-15 -13.1,-15",
    clipPath: "url(#SVGID_2_)",
    id: "path10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 253.3,280.2 c 0,-7.6 -3.6,-12.8 -10.2,-12.8 l -7.6,0.6 v 27.2 h 7.3 c 6.7,0 10.5,-6.4 10.5,-15",
    clipPath: "url(#SVGID_2_)",
    id: "path12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 432.8,267.4 -5.8,0.6 -18.8,60.4 -6.5,1.5 -14.5,-44.2 -12.5,42.6 -6.5,1.5 -13.7,-42 c -6.8,0.7 -10.2,7.7 -10.2,18.2 0,10.1 3.5,17.8 9.4,17.8 2.3,0 3.4,-0.6 6.4,-2.7 l 1.7,-1.1 0.2,1.2 -12.1,9.3 c -9.8,0 -17,-9 -17,-20.3 0,-12.1 5.8,-21.8 19.8,-24.6 0.3,0 0.7,0 1,0 L 348,268 l -5.1,-0.6 v -1.2 h 24.7 v 1.2 l -7,0.6 15.6,49.6 10.1,-34.7 -4.8,-14.8 -5,-0.6 v -1.2 h 24.6 v 1.2 l -6.9,0.6 15.5,49.6 15.4,-49.6 -7.5,-0.6 v -1.2 h 15.2 z m -101.5,61.8 h -25.8 v -1.1 l 7.3,-0.7 -6.7,-20.6 h -21.8 l -7.1,20.6 7.4,0.7 v 1.1 H 269.3 V 328 l 5.8,-0.6 20.9,-58.8 8.5,-3.6 21,62.4 5.8,0.6 z m -87.5,0 H 216.4 V 328 l 6.5,-0.6 V 268 l -6.5,-0.6 v -1.2 h 30.3 c 11.5,0 17.4,6.7 17.4,13.8 0,9.1 -8.5,15.3 -20,15.7 16.2,0.3 22.8,7.2 22.8,15.5 0.2,11.4 -8.9,17.5 -23.1,18 M 195,342.3 h 258 v -89 H 195 Z",
    clipPath: "url(#SVGID_2_)",
    id: "path14"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "305.5,305.2 295.7,274.4 284.9,305.2 ",
    id: "polygon18",
    transform: "translate(-195,-253.3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAdWLogo);
export default __webpack_public_path__ + "static/media/BAdW_Logo.9c94ef5c48bf2c101034f24a636f9cc4.svg";
export { ForwardRef as ReactComponent };